import { render, staticRenderFns } from "./WordModal.vue?vue&type=template&id=540e405e&scoped=true"
import script from "./WordModal.vue?vue&type=script&lang=js"
export * from "./WordModal.vue?vue&type=script&lang=js"
import style0 from "./WordModal.vue?vue&type=style&index=0&id=540e405e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e405e",
  null
  
)

export default component.exports